// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"loadingSpinner_loadingSpinner__3eP17","spinner":"loadingSpinner_spinner__26TJm","spinnerContainer":"loadingSpinner_spinnerContainer__3nLEg"};